import { mapState } from 'vuex';
import { AppState } from '@/vuex/store';
import { Account, AccountState } from '@/common/models/Account';
import Task from '@/common/models/Task';
import Topic from '@/settings/models/Topic';

export default {
  computed: mapState({
    hasLoginAccount(state: AppState): boolean {
      return state.accountState.hasLoginAcount;
    },
    hasLogin(state: AppState): boolean {
      return state.accountState.hasLogin;
    },
    showTaskEntry(state: AppState): boolean {
      return state.customerState.showTaskEntry;
    },
    account(state: AppState): Account {
      return state.accountState.account!;
    },
    accountState(state: AppState): AccountState {
      return state.accountState;
    },
    tasks(state: AppState): Task[] {
      return state.commonState.tasks;
    },
    topics(state: AppState): Topic[] {
      return state.commonState.topics;
    },
  }),
};
